// extracted by mini-css-extract-plugin
export default {"registration":"itemRegistration_registration__27rYp","registration_heading":"itemRegistration_registration_heading__0oOBf","add_btn":"itemRegistration_add_btn__RDIDg"};